import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import {Message as MessageIcon} from '@material-ui/icons';

import { SpecCommentsModal } from '../components/Modal';
import { SpecCommentsProps } from '../components/Spec/SpecComments';

const useSpecComments = () => {
  const [specId, setSpecId] = useState<string>('');

  const open = (options: Pick<SpecCommentsProps, 'specId'>) => {
    setSpecId(options.specId);
  };

  const renderModal = (options?: Pick<SpecCommentsProps, 'onCommentRead'>) => {
    return (
      <SpecCommentsModal
        onCommentRead={options?.onCommentRead}
        specId={specId}
        open={!!specId}
        onClose={() => setSpecId('')}
      />
    );
  };

  const renderOpenButton = (options: Pick<SpecCommentsProps, 'specId'>) => {
    return (
      <Button
        type="button"
        size="small"
        onClick={() => open(options)}
        startIcon={<MessageIcon />}
        variant="outlined"
        color="primary"
      >
        Notes
      </Button>
    );
  };

  return {
    open,
    renderModal,
    renderOpenButton
  };
};

export default useSpecComments;
